import React from 'react';

export default React.memo(() => {
    return (
        <>
        </>
    );
})